import { watch } from "vue"

/**
 * Applies a watch to the user details to ensure the contact email matches if one isn't set
 * 
 * @param {Object} form 
 */
export function createFormFieldTicketWatch(form, data){
    watch(() => form.fields.value.ticket.ticket, (newTicket) => {
        data.event.ticket.value = newTicket
    }, { immediate: true })
}